import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, FormGroup, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Directive({
  selector: '[appCheckInputNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CheckInputNumberDirective, multi: true }]
})
export class CheckInputNumberDirective {
  @Input() appCheckInputNumber = [];
  validate(formGroup: FormGroup): ValidationErrors {
    return this.checkForUnicode(this.appCheckInputNumber)(formGroup);
  }

  private checkForUnicode(controlName: string[]) {
    return (formGroup: FormGroup) => {
      const controlCheck = formGroup.controls[controlName[0]];
      const controlCheck1 = formGroup.controls[controlName[1]];
      const controlCheck2 = formGroup.controls[controlName[2]];
      const controlCheck3 = formGroup.controls[controlName[3]];
      const controlCheck4 = formGroup.controls[controlName[4]];

      // if (controlCheck != null && controlCheck.value != null && controlCheck.value !== '') {
      //   if (controlCheck.value.match(/\d{10,13}/g) == controlCheck.value
      //     || controlCheck.value.match(/\d{10,13}[-]\d{1,3}/g) == controlCheck.value) {

      //     let tempTaxCode = controlCheck.value.trim();
      //     // replace - by "".
      //     tempTaxCode = tempTaxCode.replace('-', '');

      //     const firstCode = tempTaxCode.substring(0, 10).trim();
      //     if (firstCode.length < 10) {
      //       controlCheck.setErrors({ validIp: true });
      //     }

      //     let secondCode = '';
      //     if (tempTaxCode.length > 10) {
      //       secondCode = tempTaxCode.substring(10, tempTaxCode.length ).trim();
      //     }

      //     // string to array of numbers.
      //     const firstCodeArr = firstCode.split('');

      //     const a =
      //       // 31*số đầu tiên bên trái
      //       Number(firstCodeArr[0]) * 31
      //       // 29*số thứ 2
      //       + Number(firstCodeArr[1]) * 29
      //       // 23*số thứ 3
      //       + Number(firstCodeArr[2]) * 23
      //       // 19*số thứ 4
      //       + Number(firstCodeArr[3]) * 19
      //       // 17*số thứ 5
      //       + Number(firstCodeArr[4]) * 17
      //       // 13*số thứ 6
      //       + Number(firstCodeArr[5]) * 13
      //       // 7* số thứ 7
      //       + Number(firstCodeArr[6]) * 7
      //       // 5*số thứ 8
      //       + Number(firstCodeArr[7]) * 5
      //       // 3*số thứ 9.
      //       + Number(firstCodeArr[8]) * 3;

      //     // Lấy số A chia cho 11 lấy phần dư là số B,
      //     const b = a % 11;
      //     if (10 - b !== Number(firstCodeArr[9])) {
      //       controlCheck.setErrors({ validIp: true });
      //     }

      //     // not exist second code.
      //     if (secondCode.length !== 0 && secondCode.length !== 3) {
      //       controlCheck.setErrors({ validIp: true });
      //     }
      //   } else {
      //     controlCheck.setErrors({ validIp: true });
      //   }
      // }

      if (controlCheck1 != null && controlCheck1.value != null && controlCheck1.value !== '') {
        let initalValue = controlCheck1.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z]*/g, '');

        if (initalValue !== controlCheck1.value) {
          controlCheck1.setErrors({ validIp: true });
        } else {
          controlCheck1.setErrors(null);
        }
      }

      // check all certificate
      if (controlCheck2 != null && controlCheck2.value != null && controlCheck2.value !== '') {
        let initalValue = controlCheck2.value;
        initalValue = initalValue.replace(/[~!@#$%^&*()_+*?<>,.;:=`"'|\\ ]*/g, '');
        if (initalValue === controlCheck2.value) {
          controlCheck2.setErrors(null);
        } else {
          controlCheck2.setErrors({ validInput: true });
        }
      }

      // check all certificate
      if (controlCheck3 != null && controlCheck3.value != null && controlCheck3.value !== '') {
        let initalValue = controlCheck3.value;
        initalValue = initalValue.replace(/[~!@#$%^&*()_+*?<>,.;:=` ]*/g, '');

        if (initalValue === controlCheck3.value) {
          controlCheck3.setErrors(null);
        } else {
          controlCheck3.setErrors({ validInput: true });
        }
      }

      if (controlCheck4 != null && controlCheck4.value != null && controlCheck4.value !== '') {
        const regex = /[^a-zA-Z0-9\_\\\ ]/gm;
        const result = regex.test(controlCheck4.value);
        if (result) {
          controlCheck4.setErrors({ validIp: true });
        } else {
          controlCheck4.setErrors(null);
        }
      }

      if (!controlCheck1 || isNullOrUndefined(controlCheck1.value) || controlCheck1.value === '') {
        return null;
      }

    };
  }
}
